"use strict";

export default {
  async getProducts({ commit }, payload) {
    const { api, page = 1, limit = 5, search = "" } = payload;

    try {
      const res = await api.get(
        `/products?page=${page}&limit=${limit}&search=${search}`
      );
      commit("setProduct", res.data.data);
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async createProduct(_, payload) {
    const { api, ...rest } = payload;

    try {
      const res = await api.post(`/products/create`, { ...rest });
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async updateProduct(_, payload) {
    const { api, uuid, ...rest } = payload;

    try {
      const res = await api.patch(`/products/update/${uuid}`, { ...rest });
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async getProduct(_, payload) {
    const { api, uuid } = payload;

    try {
      const res = await api.get(`/products/detail/${uuid}`);
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },

  async deleteProduct(_, payload) {
    const { api, uuid } = payload;

    try {
      const res = await api.delete(`/products/${uuid}`);
      return res.data;
    } catch (err) {
      console.error(err);
      throw new Error(
        err.response.data.message || err.message || "Unknown error"
      );
    }
  },
};
